import { sm2 } from 'sm-crypto'
import { useRequest } from 'ahooks'

import { Title } from 'components'
import { Table } from '@sar/component'

import { TreeSelect } from 'antd'
import { ModalForm, ProFormText, ProFormSwitch, ProFormTreeSelect, ProFormSelect, ProFormDependency } from '@ant-design/pro-components'

async function fetchData(params, store) {
  const result = await store.externals.api.get('/emp/list', {
    params: {
      page: params.current,
      size: params.pageSize,
    }
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

function Create ({ store, visible, handles, onVisibleChange }) {
  const roles = useRequest(async () => {
    const result = await store.externals.api.get('/role/list', {
      params: {
        page: 0,
        size: 1000,
      }
    })

    return result.map(elm => ({
      value: elm.id,
      label: elm.name,
    }))
  })

  return <ModalForm
    title='新建员工'
    layout='vertical'
    grid={true}
    width={800}
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true,
    }}
    onOpenChange={onVisibleChange}
    onFinish={data => store.externals.api.post('/emp', { ...data, password: store.encrypt.encode(data.password) }).then(() => handles.current.reload()).then(R.T)}
  >
    <ProFormText
      name='name'
      label='用户名'
      colProps={{ xl: 12 }}
      rules={[ { required: true, message: '请输入用户名' } ]}
    />

    <ProFormText
      name='nickname'
      label='昵称'
      colProps={{ xl: 12 }}
      rules={[ { required: true, message: '请输入昵称' } ]}
    />

    <ProFormText.Password
      name='password'
      label='登录密码'
      colProps={{ xl: 12 }}
      rules={[ { required: true, message: '请输入登录密码' }, { min: 6, message: '密码必须6位以上' } ]}
    />

    <ProFormText.Password
      name='repassword'
      label='确认密码'
      colProps={{ xl: 12 }}
      transform={() => null}
      rules={[
        { required: true, message: '请确认您的登录密码' },
        form => ({ validator: (_, value) => form.getFieldValue('password') == value ? Promise.resolve() : Promise.reject('密码不一致')}),
      ]}
    />

    <ProFormText
      name='contactNumber'
      label='电话'
      colProps={{ xl: 12 }}
      rules={[
        { required: true, message: '请输入电话' },
        { validator: (_, value) => /^1\d{10}$/.test(value) ? Promise.resolve() : Promise.reject('请输入正确的电话号码') },
      ]}
    />

    <ProFormSelect
      name='roles'
      label='角色'
      options={roles.data}
      colProps={{ xl: 12 }}
      fieldProps={{ maxTagCount: 2, mode: 'multiple', showSearch: true }}
    />

    <ProFormSwitch
      name='isDealer'
      label='是否是经销商'
      colProps={{ xl: 12 }}
      transform={value => ({ isDealer: value ? 'yes' : 'no' })}
    />

    <ProFormDependency name={[ 'isDealer' ]}>
      {({ isDealer }) => {
        if (isDealer != 'yes') {
          return null
        }

        return <ProFormTreeSelect
          name='sourceId'
          label='经销商来源'
          colProps={{ xs: 12 }}
          rules={[ { required: true, message: '请输入经销商来源' } ]}
          request={() => store.externals.api.get(`/constant/source`)}
          fieldProps={{ fieldNames: { value: 'id', label: 'source' } }}
        />
      }}
    </ProFormDependency>
  </ModalForm>
}

function Update ({ data, store, visible, handles, onVisibleChange }) {
  const roles = useRequest(async () => {
    const result = await store.externals.api.get('/role/list', {
      params: {
        page: 0,
        size: 1000,
      }
    })

    return result.map(elm => ({
      value: elm.id,
      label: elm.name,
    }))
  })

  return <ModalForm
    title='修改用户'
    layout='vertical'
    grid={true}
    width={800}
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true,
    }}
    onOpenChange={onVisibleChange}
    request={() =>  store.externals.api.get(`/emp/${data.id}`)}
    onFinish={params => store.externals.api.put(`/emp/${data.id}`, params).then(() => handles.current.reload()).then(R.T)}
  >
    <ProFormText
      name='name'
      label='用户名'
      colProps={{ md: 12, xl: 12 }}
      rules={[ { required: true, message: '请输入用户名' } ]}
    />

    <ProFormText
      name='contactNumber'
      label='电话'
      colProps={{ md: 12, xl: 12 }}
      rules={[
        { required: true, message: '请输入电话' },
        { validator: (_, value) => /^1\d{10}$/.test(value) ? Promise.resolve() : Promise.reject('请输入正确的电话号码') },
      ]}
    />

    <ProFormText
      name='nickname'
      label='昵称'
      colProps={{ md: 12, xl: 12 }}
      rules={[ { required: true, message: '请输入昵称' } ]}
    />

    <ProFormSelect
      name='roles'
      label='角色'
      options={roles.data}
      colProps={{ xl: 12 }}
      fieldProps={{ maxTagCount: 2, mode: 'multiple', showSearch: true }}
    />

    <ProFormSwitch
      name='isDealer'
      label='是否是经销商'
      colProps={{ xl: 12 }}
      transform={value => ({ isDealer: R.is(String, value) ? value : value ? 'yes' : 'no' })}
      convertValue={value => R.is(String, value) ? value == 'yes' : value}
    />

    <ProFormDependency name={[ 'isDealer' ]}>
      {({ isDealer }) => {
        if (isDealer != 'yes') {
          return null
        }

        return <ProFormTreeSelect
          name='sourceId'
          label='经销商来源'
          colProps={{ xs: 12 }}
          rules={[ { required: true, message: '请输入经销商来源' } ]}
          request={() => store.externals.api.get(`/constant/source`)}
          fieldProps={{ fieldNames: { value: 'id', label: 'source' } }}
        />
      }}
    </ProFormDependency>
  </ModalForm>
}

function Password({ data, store, visible, handles, onVisibleChange }) {
  return <ModalForm
    title='修改密码'
    layout='horizontal'
    width={500}
    open={visible}
    modalProps={{
      centered: true,
      maskClosable: false,
      destroyOnClose: true,
    }}
    onOpenChange={onVisibleChange}
    onFinish={params => store.externals.api.put(`/auth/password/${data.id}`, { password: store.encrypt.encode(params.password) }).then(R.T)}
  >
    <ProFormText.Password
      name='password'
      label='登录密码'
      rules={[ { required: true, message: '请输入登录密码' }, { min: 6, message: '密码必须6位以上' } ]}
    />

    <ProFormText.Password
      name='repassword'
      label='确认密码'
      transform={() => null}
      rules={[ { required: true, message: '请确认您的登录密码' }, form => ({ validator: (_, value) => form.getFieldValue('password') == value ? Promise.resolve() : Promise.reject('密码不一致')}) ]}
    />
  </ModalForm>
}

export default function({ store }) {
  const columns = [
    {
      title: '用户名',
      dataIndex: 'name',
      hideInSearch: true,
    },
    {
      title: '昵称',
      dataIndex: 'nickname',
      hideInSearch: true,
    },
    {
      title: '电话',
      dataIndex: 'contactNumber',
      hideInSearch: true,
      render: _ => _?.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      valueType: 'datetime',
      hideInSearch: true,
    },
  ]

  const actions = [
    {
      name: '新增',
      type: 'trigger',
      form: props => <Create {...props} store={store} />,
      visible: () => store.identity.hasPermission('/system/users:create'),
    },
  ]

  const rowActions = [
    {
      name: '修改',
      form: props => <Update {...props} store={store} />,
      visible: () => store.identity.hasPermission('/system/users:update'),
    },
    {
      name: '重置密码',
      form: props => <Password {...props} store={store} />,
      visible: () => store.identity.user.roles?.findIndex(role => [ 1, 26 ].includes(role.id)) != -1,
    },
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这个员工吗？',
      visible: () => store.identity.hasPermission('/system/users:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/emp/${data.id}`).then(() => handles.current.reload()),
    },
  ]

  return <div className='p-4'>
    <Table
      title='员工列表'
      columns={columns}
      actions={actions}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
    />
  </div>
}
